export class CalendarEvent {
  from?: Date;
  to?: Date;
  type: string = '';

  constructor(init?: Partial<CalendarEvent>) {
    if (init) Object.assign(this, init);
  }
}
